import DataDlIcon from "../../../icons/DataDlIcon";
import EmailIcon from "../../../icons/EmailIcon";
import GroupIcon from "../../../icons/GroupIcon";
import LabelIcon from "../../../icons/LabelIcon";
import ListIcon from "../../../icons/ListIcon";
import UpdateIcon from "../../../icons/UpdateIcon";
import WordDocumentIcon from "../../../icons/WordDocumentIcon";
import { NavLink } from "react-router-dom";
import DocumentIcon from "../../../icons/DocumentIcon";

export default function Sidebar() {
  return (
    <aside className="l-sidebar l-sidebar--regular col-auto ">
      <dl className="c-item-list flex-column gap-4">
        <div className="gap-1">
          <h3 className="form-label px-3">Skabeloner</h3>
          <NavLink
            to="/admin/mailskabeloner"
            className={({ isActive }) =>
              isActive ? "nav-link--active w-100" : "nav-link w-100"
            }
          >
            <span className="d-flex w-100 flex-row align-items-center gap-3 py-2 px-3 rounded">
              <EmailIcon width={15} />
              <span>Mail-skabeloner</span>
            </span>
          </NavLink>
          <NavLink
            to="/admin/dokumentskabeloner"
            className={({ isActive }) =>
              isActive ? "nav-link--active w-100" : "nav-link w-100"
            }
          >
            <span className="d-flex w-100 flex-row align-items-center gap-3 py-2 px-3 rounded">
              <WordDocumentIcon width={16} />
              <span>Dokumentskabeloner</span>
            </span>
          </NavLink>
        </div>
        <div className="gap-1">
          <h3 className="form-label px-3">Data</h3>
          <NavLink
            to="/admin/dataudtræk"
            className={({ isActive }) =>
              isActive ? "nav-link--active w-100" : "nav-link w-100"
            }
          >
            <span className="d-flex w-100 flex-row align-items-center gap-3 py-2 px-3 rounded">
              <DataDlIcon width={16} />
              <span>Dataudtræk</span>
            </span>
          </NavLink>
          <NavLink
            to="/admin/prissætning"
            className={({ isActive }) =>
              isActive ? "nav-link--active w-100" : "nav-link w-100"
            }
          >
            <span className="d-flex w-100 flex-row  align-items-center gap-3 py-2 px-3 rounded">
              <LabelIcon width={16} />
              <span>Prissætning</span>
            </span>
          </NavLink>
          <NavLink
            to="/admin/jobs"
            className={({ isActive }) =>
              isActive ? "nav-link--active w-100" : "nav-link w-100"
            }
          >
            <span className="d-flex w-100 flex-row  align-items-center gap-3 py-2 px-3 rounded">
              <UpdateIcon width={17} />
              <span>Jobs / kørsler</span>
            </span>
          </NavLink>
          <NavLink
            to="/admin/kodelister"
            className={({ isActive }) =>
              isActive ? "nav-link--active w-100" : "nav-link w-100"
            }
          >
            <span className="d-flex w-100 flex-row  align-items-center gap-3 py-2 px-3 rounded">
              <ListIcon width={15} />
              <span>Kodelister</span>
            </span>
          </NavLink>
          <NavLink
            to="/admin/rapporter"
            className={({ isActive }) =>
              isActive ? "nav-link--active w-100" : "nav-link w-100"
            }
          >
            <span className="d-flex w-100 flex-row  align-items-center gap-3 py-2 px-3 rounded">
              <DocumentIcon height={16} />
              <span className="form-control--value">Rapporter</span>
            </span>
          </NavLink>
        </div>
        <div className="gap-1">
          <h3 className="form-label px-3">Brugere</h3>
          <NavLink
            to="/admin/brugere"
            className={({ isActive }) =>
              isActive ? "nav-link--active w-100" : "nav-link w-100"
            }
          >
            <span className="d-flex w-100 flex-row align-items-center gap-3 py-2 px-3 rounded">
              <GroupIcon width={18} />
              <span className="form-control--value">Brugere</span>
            </span>
          </NavLink>
        </div>
      </dl>
    </aside>
  );
}
